"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isAssignedContent(enrolment) {
    try {
        if (!enrolment || enrolment.deleted) {
            return false;
        }
        return true;
    }
    catch (error) {
        throw error;
    }
}
exports.default = isAssignedContent;
//# sourceMappingURL=isAssigned.js.map